import type { IconData } from '@stacksjs/iconify-core'

export const gm1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"red\" d=\"M0 0h512v170.7H0z\"/><path fill=\"#fff\" d=\"M0 170.7h512V199H0z\"/><path fill=\"#009\" d=\"M0 199.1h512V313H0z\"/><path fill=\"#fff\" d=\"M0 312.9h512v28.4H0z\"/><path fill=\"#090\" d=\"M0 341.3h512V512H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gm1x1
